// Silent default schedule. First-run writes a generous waking-hours schedule so
// the overlap has working hours to intersect — evenings and weekends included
// (the product deliberately surfaces free time outside 9-5). Idempotent: only
// writes if the user has no default yet.
import { apiFetch } from '../lib/api';

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

// Waking hours, every day. 08:00–22:00 local.
const DEFAULT_WEEKLY_HOURS = DAYS.map((day) => ({ day, start: '08:00', end: '22:00' }));

export async function ensureDefaultSchedule() {
  const existing = await apiFetch('/v1/schedules').catch(() => null);
  const schedules = existing?.schedules || existing?.data || existing || [];
  const hasDefault = Array.isArray(schedules) && schedules.some((s) => s.is_default);
  if (hasDefault) return { created: false };

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  await apiFetch('/v1/schedules', {
    method: 'POST',
    body: {
      name: 'Waking hours',
      timezone,
      weekly_hours: DEFAULT_WEEKLY_HOURS,
      is_default: true,
    },
  });
  return { created: true };
}
